export const langWithoutRegion = (lang: string) => lang.split('-')[0]!
